import { useMutation, useQueryClient } from '@tanstack/react-query';
import InteractionService from '@/services/InteractionService';
import { INTERACTION_KEYS } from './keys';

/** Manual time entry (Log time modal). Minutes in — the service gets whole-minute seconds. */
export function useLogTime() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: {
      userid: string | number;
      minutes: number;
      dateYmd: string;
      authorid?: string | number;
      note?: string;
    }) => InteractionService.createTimeEntry({
      userid: vars.userid,
      timeSeconds: vars.minutes * 60,
      dateYmd: vars.dateYmd,
      authorid: vars.authorid,
      note: vars.note,
    }),
    onSuccess: () => qc.invalidateQueries({ queryKey: INTERACTION_KEYS.all }),
  });
}

/** Inline edit of an existing entry's duration (bounded 1–120 min by the caller). */
export function useUpdateTimeEntry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { entryId: string | number; minutes: number }) => (
      InteractionService.updateTimeEntry({ entryId: vars.entryId, timeSeconds: vars.minutes * 60 })
    ),
    onSuccess: () => qc.invalidateQueries({ queryKey: INTERACTION_KEYS.all }),
  });
}
